const VOICE_KEY = "fathom_voice";
const SPEED_KEY = "fathom_speed";

export const SPEEDS = [0.75, 1, 1.25, 1.5, 2];

// OpenAI TTS voices supported by the backend.
export const VOICES = [
  { id: "nova", label: "Nova", desc: "Warm & friendly" },
  { id: "shimmer", label: "Shimmer", desc: "Bright & gentle" },
  { id: "alloy", label: "Alloy", desc: "Neutral & clear" },
  { id: "echo", label: "Echo", desc: "Calm & even" },
  { id: "fable", label: "Fable", desc: "Storyteller" },
  { id: "onyx", label: "Onyx", desc: "Deep & steady" },
];

export function getVoice() {
  const v = localStorage.getItem(VOICE_KEY);
  return VOICES.some((x) => x.id === v) ? v : "nova";
}

export function setVoice(v) {
  localStorage.setItem(VOICE_KEY, v);
  window.dispatchEvent(new CustomEvent("fathom-voice-change", { detail: v }));
}

export function getSpeed() {
  const s = parseFloat(localStorage.getItem(SPEED_KEY));
  return SPEEDS.includes(s) ? s : 1;
}

export function setSpeed(s) {
  localStorage.setItem(SPEED_KEY, String(s));
}
